import { LoggerFactory } from './factories/logger.factory';

export const sendLogs = LoggerFactory.sendLogs;
export const logger = LoggerFactory.getLogger();
export const setLoggerConfig = LoggerFactory.setLoggerConfig;
export const setLoggerStreams = LoggerFactory.setLoggerStreams;
